import Bodoni72Smallcaps from "../assets/fonts/Bodoni 72 Smallcaps Book.ttf";
import { StyleSheet, Dimensions } from "react-native";

const { width, height } = Dimensions.get('window');

// Get device pixel ratio to detect high-DPI displays
const pixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;

// Calculate "logical" width (actual perceived size)
const logicalWidth = width / pixelRatio;

// Responsive breakpoints based on logical size + physical characteristics
const isMobile = width < 768;
const isTablet = width >= 768 && width < 1024;
// For high-DPI use logical width or smaller threshold
const isLaptop = (width >= 1024 && width < 1920) || (pixelRatio > 1.5 && width < 1920);
const isLargeDesktop = width >= 1920;

const fontFamilies = {
	Bodoni72Smallcaps: "Bodoni72Smallcaps",
};

const styles = StyleSheet.create({
	body: {
		flex: 1,
		position: "relative",
		backdropFilter: "blur(10px)",
		minHeight: "100vh",
		width: "100%",
		overflowX: "hidden",
	},
	section: {
		flex: 1,
		width: "100%",
		overflowX: "hidden",
		zIndex: 1,
		justifyContent: "flex-start",
		alignContent: "center",
		paddingBottom: isMobile ? 80 : isTablet ? 100 : 120,
		paddingTop: isMobile ? 0 : isTablet ? 55 : 65,
		position: "relative",
	},
	backgroundImage: {
		flex: 1,
		resizeMode: "cover",
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		width: "100%",
		height: "100%",
		minHeight: "100vh",
		backgroundSize: "cover",
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat",
		backgroundAttachment: "fixed",
		zIndex: 0,
	},
	headerBar: {
		flex: 1,
		flexDirection: "row",
		justifyContent: "space-between",
		backgroundColor: "transparent",
		paddingHorizontal: isMobile ? 0 : isTablet ? 50 : 100,
		paddingTop: isMobile ? 15 : isTablet ? 30 : 50,
		position: "relative",
		width: "100%",
		zIndex: 98,
	},
	logoArea: {
		flex: 1,
		flexDirection: "row",
		justifyContent: "space-between",
		backgroundColor: "transparent",
		maxHeight: isMobile ? 30 : isTablet ? 40 : 50,
		height: 62,
		marginTop: 10,
	},
	logoText: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontWeight: "normal",
		fontSize: isMobile ? 18 : isTablet ? 25 : 40,
		marginLeft: isMobile ? 25 : 0,
		textAlign: "left",
		color: "#fefde2",
		textShadow: "3px 3px 6px rgba(0, 0, 0, 0.09)",
	},
	loginArea: {
		marginRight: isMobile ? 250 : isTablet ? 250 : 0,
		flex: 1,
		flexDirection: "row",
		backgroundColor: "transparent",
		maxHeight: 50,
	},
	logoutButton: {
		width: 208,
		height: 62,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
		zIndex: 99,
		marginLeft: isMobile ? 15 : isTablet ? 180 : 350,
		top: isMobile ? -10 : 0,
	},
	loginButton: {
		width: 208,
		height: 62,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
		zIndex: 99,
		marginLeft: isMobile ? 15 : isTablet ? 180 : 350,
		top: isMobile ? -10 : 0,
	},
	loginButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 20 : isTablet ? 25 : 28,
		lineHeight: 30,
		textAlign: "center",
		color: "#e4e4e4",
		textShadow: "3px 3px 6px rgba(0, 0, 0, 0.09)",
	},
	cancelButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 20 : isTablet ? 25 : 28,
		textAlign: "center",
		color: "#e4e4e4",
		textShadow: "3px 3px 6px rgba(0, 0, 0, 0.09)",
		marginHorizontal: 25,
		paddingRight: 90,
	},
	signOutButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 20 : isTablet ? 25 : 28,
		textAlign: "center",
		color: "red",
		textShadow: "3px 3px 6px rgba(0, 0, 0, 0.09)",
	},

	buttonText: {
		fontFamily: "Orpheus Pro",
		fontWeight: "600",
		fontSize: isMobile ? 16 : isTablet ? 18 : isLaptop ? 20 : 24,
		lineHeight: isMobile ? 22 : 28,
		letterSpacing: 0.4,
		textAlign: "center",
		color: "#fefde2",
		textShadow: "1px 1px 3px rgba(0, 0, 0, 0.15)",
	},
	welcomeArea: {
		marginTop: isMobile ? -100 : isTablet ? 15 : 20,
		width: "100%",
		justifyContent: "center",
		alignItems: "center",
		paddingHorizontal: isMobile ? 20 : 0,
	},
	descriptionArea: {
		width: "100%",
		height: "auto",
		backgroundColor: "transparent",
		paddingHorizontal: isMobile ? 20 : isTablet ? 45 : 100,
		paddingBottom: isMobile ? 18 : isTablet ? 23 : 35,
		marginBottom: isMobile ? 10 : isTablet ? 15 : 25,
	},
	welcomeText: {
		width: isMobile ? "92vw" : isTablet ? "85vw" : "80vw",
		maxWidth: 1200,
		minHeight: isMobile ? 60 : isTablet ? 80 : 100,
		height: "auto",
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontSize: isMobile ? 42 : isTablet ? 72 : isLaptop ? 85 : 110,
		letterSpacing: isMobile ? 1 : 2,
		marginTop: isMobile ? 100 : isTablet ? 60 : isLaptop ? 80 : 140,
		lineHeight: isMobile ? 50 : isTablet ? 80 : isLaptop ? 95 : 120,
		textAlign: "center",
		color: "#fefde2",
		textShadow: "2px 4px 8px rgba(0, 0, 0, 0.18)",
		alignSelf: "center",
	},

	descriptionText: {
		width: isMobile ? "88vw" : isTablet ? 580 : isLaptop ? "58vw" : "50vw",
		maxWidth: 900,
		minHeight: isMobile ? 80 : isTablet ? 100 : isLaptop ? 90 : 95,
		height: "auto",
		fontFamily: "Orpheus Pro",
		fontWeight: "400",
		fontSize: isMobile ? 18 : isTablet ? 28 : isLaptop ? 42 : 54,
		lineHeight: isMobile ? 28 : isTablet ? 40 : isLaptop ? 48 : 58,
		letterSpacing: 0.3,
		color: "rgba(254, 253, 226, 0.94)",
		textShadow: "1px 2px 4px rgba(0, 0, 0, 0.14)",
		textAlign: "center",
		alignSelf: "center",
		paddingTop: isMobile ? 16 : isTablet ? 16 : 24,
	},

	buttonsContainer: {
		flexDirection: isMobile ? "column" : "row",
		flexWrap: isTablet ? "wrap" : "nowrap",
		maxWidth: isMobile ? 380 : isTablet ? 620 : isLaptop ? 1000 : 1400,
		alignSelf: "center",
		marginTop: isMobile ? 18 : isTablet ? 18 : isLaptop ? 100 : 100,
		flex: 1,
		position: "relative",
		zIndex: 5,
		justifyContent: "center",
		alignItems: isMobile ? "center" : "flex-start",
		gap: isTablet ? 16 : 0,
	},

	buttonArea: {
		marginHorizontal: isMobile ? 35 : isTablet ? 35 : 35,
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "center",
		alignSelf: "stretch",
		zIndex: 1000,
		marginBottom: isMobile ? 18 : 0,
	},

	button: {
		width: isMobile ? 270 : isTablet ? 290 : isLaptop ? 300 : 340,
		height: isMobile ? 53 : isTablet ? 58 : isLaptop ? 60 : 70,
		marginBottom: isMobile ? 18 : 0,
		backgroundColor: "#4c956c",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: 40,
	},

	buttonDescription: {
		width: isMobile ? 200 : isTablet ? 200 : 260,
		height: isMobile ? "auto" : 90,
		paddingTop: isMobile ? 12 : isTablet ? 14 : 18,
		paddingHorizontal: 8,
		fontFamily: "Orpheus Pro",
		fontWeight: "500",
		fontSize: isMobile ? 13 : isTablet ? 14 : 16,
		lineHeight: isMobile ? 20 : isTablet ? 22 : 24,
		letterSpacing: 0.2,
		textAlign: "center",
		color: "rgba(254, 253, 225, 0.88)",
		textShadow: "1px 2px 4px rgba(0, 0, 0, 0.14)",
		alignSelf: "center",
	},

	// Styles for the custom modal
	centeredView: {
		flex: 1,
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		backdropFilter: "blur(8px)",
	},
	modalView: {
		padding: isMobile ? 24 : 32,
		backgroundColor: "#fefde2",
		borderRadius: 20,
		shadowColor: "#000",
		shadowOffset: { width: 0, height: 8 },
		shadowOpacity: 0.2,
		shadowRadius: 24,
		elevation: 12,
		margin: 20,
		alignItems: "center",
		maxWidth: isMobile ? "90%" : 420,
		width: "100%",
	},
	buttonOpen: {
		backgroundColor: "#4c956c",
		borderRadius: 24,
		paddingVertical: 12,
		paddingHorizontal: 24,
		elevation: 4,
		marginTop: 16,
		shadowColor: "#1a5c3a",
		shadowOffset: { width: 0, height: 3 },
		shadowOpacity: 0.2,
		shadowRadius: 6,
		minWidth: 120,
	},
	buttonClose: {
		backgroundColor: "#e74c3c",
		borderRadius: 24,
		paddingVertical: 12,
		paddingHorizontal: 24,
		elevation: 4,
		marginTop: 12,
		shadowColor: "#c0392b",
		shadowOffset: { width: 0, height: 3 },
		shadowOpacity: 0.2,
		shadowRadius: 6,
		minWidth: 120,
	},
	textStyle: {
		fontFamily: "Orpheus Pro",
		fontSize: 15,
		fontWeight: "600",
		letterSpacing: 0.3,
		textAlign: "center",
		color: "#fefde2",
		marginHorizontal: 8,
	},
	modalText: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 18 : 20,
		fontWeight: "600",
		textAlign: "center",
		color: "#2c3e50",
		marginBottom: 8,
		lineHeight: isMobile ? 26 : 28,
	},
	buttonGreen: {
		backgroundColor: "#4c956c",
		paddingVertical: 14,
		paddingHorizontal: 28,
		borderRadius: 24,
		marginTop: 16,
		width: "85%",
		alignItems: "center",
		shadowColor: "#1a5c3a",
		shadowOffset: { width: 0, height: 4 },
		shadowOpacity: 0.25,
		shadowRadius: 8,
		elevation: 4,
	},
	buttonRed: {
		backgroundColor: "#e74c3c",
		paddingVertical: 14,
		paddingHorizontal: 28,
		borderRadius: 24,
		marginTop: 10,
		width: "85%",
		alignItems: "center",
		shadowColor: "#c0392b",
		shadowOffset: { width: 0, height: 4 },
		shadowOpacity: 0.25,
		shadowRadius: 8,
		elevation: 4,
	},
	smsBackfillModalView: {
		padding: isMobile ? 22 : 30,
		backgroundColor: "#fefde2",
		borderRadius: 22,
		shadowColor: "#000",
		shadowOffset: { width: 0, height: 8 },
		shadowOpacity: 0.22,
		shadowRadius: 24,
		elevation: 12,
		margin: 20,
		maxWidth: isMobile ? "92%" : 460,
		width: "100%",
		alignItems: "stretch",
	},
	smsBackfillTitle: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 22 : 26,
		fontWeight: "600",
		color: "#2c3e50",
		textAlign: "center",
		marginBottom: 14,
		lineHeight: isMobile ? 30 : 34,
	},
	smsBackfillBody: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 16 : 18,
		color: "#425466",
		textAlign: "center",
		lineHeight: isMobile ? 24 : 27,
		marginBottom: 10,
	},
	smsBackfillInput: {
		width: "100%",
		height: 52,
		borderRadius: 14,
		borderWidth: 1,
		borderColor: "rgba(76, 149, 108, 0.25)",
		backgroundColor: "#fffef4",
		paddingHorizontal: 16,
		marginTop: 14,
		fontFamily: "Orpheus Pro",
		fontSize: 16,
		color: "#2c3e50",
	},
	smsBackfillHelper: {
		fontFamily: "Orpheus Pro",
		fontSize: 13,
		color: "#6b7280",
		textAlign: "center",
		marginTop: 10,
		marginBottom: 6,
	},
	smsBackfillError: {
		fontFamily: "Orpheus Pro",
		fontSize: 13,
		color: "#c0392b",
		textAlign: "center",
		marginTop: 10,
		marginBottom: 6,
	},
	smsBackfillPrimaryButton: {
		backgroundColor: "#4c956c",
		borderRadius: 16,
		paddingVertical: 14,
		paddingHorizontal: 18,
		alignItems: "center",
		justifyContent: "center",
		marginTop: 12,
	},
	smsBackfillPrimaryButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: 16,
		fontWeight: "600",
		color: "#fefde2",
	},
	smsBackfillSecondaryButton: {
		backgroundColor: "#fff7f6",
		borderWidth: 1,
		borderColor: "#f2c4bd",
		borderRadius: 16,
		paddingVertical: 14,
		paddingHorizontal: 18,
		alignItems: "center",
		justifyContent: "center",
		marginTop: 10,
	},
	smsBackfillSecondaryButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: 16,
		fontWeight: "600",
		color: "#c0392b",
	},
	smsBackfillButtonDisabled: {
		opacity: 0.7,
	},
	overlayBlur: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backdropFilter: "blur(25px)",
		zIndex: 1,
	},
	blurredContainer: {
		position: "absolute",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		backdropFilter: "blur(10px)",
		zIndex: 9999,
	},
	ribbonContainer: {
		position: 'fixed',
		bottom: isMobile ? '23%' : 160,
		right: isMobile ? 20 : 40,
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: "#4c956c",
		padding: 10,
		borderRadius: isMobile ? 30 : 10,
		zIndex: 9999,
		width: isMobile ? 40 : 175,
		height: isMobile ? 40 : 'auto',
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8
	},
	ribbonButton: {

	},
	ribbon1: {
		position: 'absolute',
		bottom: '-100%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 100,
		width: 175,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbon2: {
		position: 'absolute',
		bottom: '-200%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 100,
		width: 175,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbon3: {
		position: 'absolute',
		bottom: '-300%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 100, 
		width: 175,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbon4: {
		position: 'absolute',
		bottom: '-300%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 100,
		width: 175,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbon5: {
		position: 'absolute',
		bottom: '-300%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 100,
		width: 175,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbon6: {
		position: 'absolute',
		bottom: '-300%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 100,
		width: 175,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbonText: {
		color: '#FFFFFF',
		fontWeight: 'bold',
		textAlign: 'center',
	},
	resourcesOverlay: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(76, 149, 108, 0.95)',
		zIndex: 10000,
		justifyContent: 'center',
		alignItems: 'center',
	},
	resourcesOverlayCloseButton: {
		position: 'absolute',
		top: 20,
		right: 20,
	
		width: 40,
		height: 40,
		borderRadius: 20,
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 10001,
	},
	resourcesOverlayCloseButtonText: {
		fontSize: 18,
		fontWeight: 'bold',
		color: '#FEFCE0',
	},
	resourcesOverlayContent: {
		width: '80%',
		maxHeight: '80%',
		borderRadius: 10,
		paddingBottom: 100,
		alignItems: 'center',
	},
	resourcesOverlayTitle: {
		fontSize: 24,
		fontWeight: 'bold',
		color: '#FEFCE0',
		marginBottom: 20,
		fontFamily: "Bodoni72Smallcaps",
	},
	resourcesOverlayItem: {
		width: '100%',
		padding: 15,
		borderRadius: 10,
		marginBottom: 10,
		alignItems: 'center',
	},
	resourcesOverlayItemText: {
		fontSize: 18,
		color: '#FEFCE0',
		textAlign: 'center',
		fontWeight: 'bold',
		fontFamily: "Bodoni72Smallcaps",
	},

	// Desktop Resources Modal (new)
	desktopResourcesButton: {
		position: 'fixed',
		bottom: isMobile ? '23%' : 50,
		right: isMobile ? 20 : 50,
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: "#4c956c",
		padding: isMobile ? 12 : 14,
		borderRadius: 28,
		zIndex: 9999,
		width: isMobile ? 48 : 160,
		height: isMobile ? 48 : 48,
		shadowColor: "#1a5c3a",
		shadowOffset: { width: 0, height: 4 },
		shadowOpacity: 0.35,
		shadowRadius: 12,
		elevation: 8,
		transition: "all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)",
		borderWidth: 1,
		borderColor: "rgba(255, 255, 255, 0.15)",
		cursor: 'pointer',
	},
	desktopResourcesButtonHover: {
		transform: [{ scale: 1.08 }, { translateY: -3 }],
		shadowOpacity: 0.5,
		shadowRadius: 18,
		backgroundColor: "#3d8059",
	},
	desktopResourcesButtonText: {
		color: '#fefde2',
		fontWeight: '600',
		textAlign: 'center',
		fontSize: 15,
		letterSpacing: 0.3,
	},
	desktopResourcesOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		zIndex: 9998,
		backdropFilter: "blur(5px)",
	},
	desktopResourcesPanel: {
		position: 'fixed',
		top: 0,
		right: 0,
		width: Math.min(300, width * 0.8),
		maxWidth: '80vw',
		height: '100%',
		backgroundColor: 'rgba(76, 149, 108, 0.95)',
		zIndex: 9999,
		boxShadow: '-5px 0 15px rgba(0, 0, 0, 0.3)',
		padding: 20,
		display: 'flex',
		flexDirection: 'column',
		overflowX: 'hidden',
	},
	desktopResourcesCloseButton: {
		position: 'absolute',
		top: 20,
		right: 20,
		width: 40,
		height: 40,
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 10000,
	},
	desktopResourcesCloseButtonText: {
		fontSize: 24,
		fontWeight: 'bold',
		color: '#FEFCE0',
	},
	desktopResourcesTitle: {
		fontSize: 30,
		fontWeight: 'bold',
		color: '#FEFCE0',
		marginTop: 40,
		marginBottom: 30,
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		textAlign: 'center',
	},
	desktopResourcesContent: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		marginBottom: 40,
		overflowY: 'auto',
	},
	desktopResourcesItem: {
		width: '100%',
		padding: 15,
		marginBottom: 10,
		borderRadius: 10,
		alignItems: 'center',
		transition: 'transform 0.2s ease',
	},
	desktopResourcesItemHover: {
		transform: [{ scale: 1.05 }],
		backgroundColor: 'rgba(255, 255, 255, 0.1)',
	},
	desktopResourcesItemText: {
		fontSize: 20,
		color: '#FEFCE0',
		textAlign: 'center',
		fontWeight: 'bold',
		fontFamily: fontFamilies.Bodoni72Smallcaps,
	},
});

export default styles;
